import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { AccessLimitService, PAYMENT_METHODS_PAGE } from '@modules/settings/services/access-limit.service';

/** Top bar of every page while the account is limited after a failed payment. It has no close control. */
@Component({
  selector: 'app-access-limit-banner',
  standalone: true,
  imports: [Button2Component, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './access-limit-banner.component.html',
})
export class AccessLimitBannerComponent {
  protected readonly accessLimit = inject(AccessLimitService);
  private readonly router = inject(Router);

  protected readonly message = computed(() => {
    const date = this.accessLimit.deletionDate();
    if (this.accessLimit.inherited()) {
      return (
        "Your team owner's payment didn't go through. AI features, sending mail and creating new items are paused. " +
        (date
          ? `Ask your team owner to update the payment method by ${date}.`
          : 'Ask your team owner to update the payment method.')
      );
    }
    return (
      "Your payment didn't go through. AI features, sending mail and creating new items are paused. " +
      (date
        ? `Update your payment method by ${date} to keep your account.`
        : 'Update your payment method to keep your account.')
    );
  });

  protected updatePaymentMethod(): void {
    void this.router.navigateByUrl(PAYMENT_METHODS_PAGE);
  }
}
